// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  game: getIcon('ic_game'),
  gamePlaylist: getIcon('ic_gamePlaylist'),
  media: getIcon('ic_media'),
  mediaPlaylist: getIcon('ic_mediaPlaylist'),
  projects: getIcon('ic_projects'),
  trafficReport: getIcon('ic_trafficReport'),
  users: getIcon('ic_users'),
  ads: getIcon('ic_ads'),
  home: getIcon('ic_home'),
  landingPage: getIcon('ic_landingPage'),
  transferringContent: getIcon('ic_transferringContent'),
  metadata: getIcon('ic_metadata'),
  wallet: getIcon('ic_wallet'),
  ball: getIcon('ic_ball'),
  social: getIcon('ic_social'),
  version_control: getIcon('ic_version_control'),
  package: getIcon('ic_package'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      { title: 'میز کار', path: PATH_DASHBOARD.general.home, icon: ICONS.home },
      { title: 'فهرست پروژه ها', path: PATH_DASHBOARD.general.projects, icon: ICONS.projects },
      { title: 'مدیریت کانتنت هاب', path: PATH_DASHBOARD.general.contentManager(), icon: ICONS.media },
      { title: 'گروه بندی محتوای مدیا', path: PATH_DASHBOARD.general.mediaGroupTypeList, icon: ICONS.mediaPlaylist },
      { title: 'مدیریت هاب بازی ها', path: PATH_DASHBOARD.general.gamesList(), icon: ICONS.game },
      { title: 'پلی لیست  بازی ها', path: PATH_DASHBOARD.general.gamePlayList(), icon: ICONS.gamePlaylist },
      { title: 'مدیریت کاربران', path: PATH_DASHBOARD.general.userList(), icon: ICONS.users },
      { title: 'گزارش سرویس بازی', path: PATH_DASHBOARD.general.gameServiceReport, icon: ICONS.trafficReport },
      { title: 'گزارش روزانه ترافیک', path: PATH_DASHBOARD.general.dailyTrafficReport, icon: ICONS.trafficReport },
      { title: 'تبلیغات', path: PATH_DASHBOARD.general.adsList, icon: ICONS.ads },
      { title: 'انتقال محتوا به کانتنت هاب', path: PATH_DASHBOARD.general.uploadToServerList(), icon: ICONS.transferringContent },
      { title: 'مدیریت لندینگ پیج ها', path: PATH_DASHBOARD.general.landingList(), icon: ICONS.landingPage },
      { title: 'مدیریت متادیتا', path: PATH_DASHBOARD.general.manageMetaData, icon: ICONS.metadata },
      { title: 'ترافیک', path: PATH_DASHBOARD.general.trafficReport, icon: ICONS.metadata },
      {
        title: 'مدیریت مالی',
        icon: ICONS.wallet,
        children: [
          { title: 'درگاه های پرداخت', path: PATH_DASHBOARD.general.gatewayList() },
          { title: 'درگاه پرداخت پروژه ها', path: PATH_DASHBOARD.general.gatewayProfileList() },
          { title: 'تنظیم درگاه پروژه', path: PATH_DASHBOARD.general.gatewayJoinProfileList() },
          { title: 'گزارش های مالی', path: PATH_DASHBOARD.general.financialReports },
        ],
      },
      {
        title: 'پروژه فوتبالپ',
        icon: ICONS.ball,
        children: [
          { title: 'کارت های بازی', path: PATH_DASHBOARD.general.gameCardList() },
          { title: 'زمین های بازی', path: PATH_DASHBOARD.general.gamePlanetList() },
          { title: 'کدهای هدیه', path: PATH_DASHBOARD.general.giftCodeList() },
        ],
      },
      {
        title: 'مدیریت سوشال',
        icon: ICONS.social,
        children: [
          { title: 'حساب کاربری', path: PATH_DASHBOARD.general.socialManagerAccountList() },
          { title: 'کانال', path: PATH_DASHBOARD.general.socialManagerChannelList() },
          { title: 'محتوا', path: PATH_DASHBOARD.general.socialManagerContentList() },
        ],
      },
      { title: 'مدیریت ورژن کنترل', path: PATH_DASHBOARD.general.manageAppVersionControl(), icon: ICONS.version_control },
      {
        title: "مدیریت بسته های اشتراک",
        icon: ICONS.package,
        children: [
          { title: 'انواع بسته های اشتراک', path: PATH_DASHBOARD.general.subscribePackageTypeList },
          { title: 'جایگاه بسته های اشتراک', path: PATH_DASHBOARD.general.subscribePackagePositionList },
        ],
      },

      // { title: 'app', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      // { title: 'e-commerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      // { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      // { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     // USER
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'profile', path: PATH_DASHBOARD.user.profile },
  //         { title: 'cards', path: PATH_DASHBOARD.user.cards },
  //         { title: 'list', path: PATH_DASHBOARD.user.list },
  //         { title: 'create', path: PATH_DASHBOARD.user.new },
  //         { title: 'edit', path: PATH_DASHBOARD.user.demoEdit },
  //         { title: 'account', path: PATH_DASHBOARD.user.account },
  //       ],
  //     },

  //     // E-COMMERCE
  //     {
  //       title: 'e-commerce',
  //       path: PATH_DASHBOARD.eCommerce.root,
  //       icon: ICONS.cart,
  //       children: [
  //         { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
  //         { title: 'product', path: PATH_DASHBOARD.eCommerce.demoView },
  //         { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
  //         { title: 'create', path: PATH_DASHBOARD.eCommerce.new },
  //         { title: 'edit', path: PATH_DASHBOARD.eCommerce.demoEdit },
  //         { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
  //       ],
  //     },

  //     // INVOICE
  //     {
  //       title: 'invoice',
  //       path: PATH_DASHBOARD.invoice.root,
  //       icon: ICONS.invoice,
  //       children: [
  //         { title: 'list', path: PATH_DASHBOARD.invoice.list },
  //         { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.invoice.new },
  //         { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
  //       ],
  //     },

  //     // BLOG
  //     {
  //       title: 'blog',
  //       path: PATH_DASHBOARD.blog.root,
  //       icon: ICONS.blog,
  //       children: [
  //         { title: 'posts', path: PATH_DASHBOARD.blog.posts },
  //         { title: 'post', path: PATH_DASHBOARD.blog.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.blog.new },
  //       ],
  //     },
  //   ],
  // },

  // // APP
  // // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: (
  //         <Label variant="outlined" color="error">
  //           +32
  //         </Label>
  //       ),
  //     },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
  //     { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban },
  //   ],
  // },
];

export default navConfig;
